import { closeDialogByName, openDialog } from '@patrianna/dialog-manager'
import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { useEffect } from 'react'

import { useAppSelector } from 'store/hooks'
import { isGameForInfiniteModeSelector, isGameOnlyForGoldModeSelector } from 'store/modules/slotGameFlow/selectors'
import { getGoldenKeySelector } from 'store/modules/user/selectors'

export default function useShowDialogOnlyScMode(gameProduct: GameProduct) {
  const goldenKey = useAppSelector(getGoldenKeySelector)
  const isGameOnlyForGoldMode = useAppSelector((state) => isGameOnlyForGoldModeSelector(state, gameProduct))
  const isGameForInfiniteMode = useAppSelector((state) => isGameForInfiniteModeSelector(state, gameProduct))

  useEffect(() => {
    // Show dialog if game is infinite and user is in SC mode
    if (isGameForInfiniteMode) {
      openDialog({ dialogName: 'GAME_ONLY_FOR_INFINITE_DIALOG' })
    } else {
      closeDialogByName({ dialogName: 'GAME_ONLY_FOR_INFINITE_DIALOG' })
    }
    // Show dialog if game is for golden key and user is in SC mode
    if (isGameOnlyForGoldMode) {
      openDialog({ dialogName: 'GAME_NOT_FOR_SC_DIALOG', dialogProps: { goldenKey } })
    } else {
      closeDialogByName({ dialogName: 'GAME_NOT_FOR_SC_DIALOG' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGameOnlyForGoldMode, isGameForInfiniteMode])

  return isGameOnlyForGoldMode || isGameForInfiniteMode
}
